import React from "react";

const compliance = [
    "ISO 9001 Certified",
    "MoEF Cleared",
    "AERB Monazite-Free",
    "R&D Lab Accredited",
];

export default function Footer() {
    return (
        <footer className="border-t border-border bg-background px-6 py-16">
            <div className="mx-auto grid max-w-screen-xl grid-cols-1 gap-12 md:grid-cols-4">
                <div className="md:col-span-2">
                    <div className="mb-6 flex items-baseline gap-2">
                        <span className="text-2xl font-bold uppercase tracking-tighter">
                            Velox
                        </span>
                        <span className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
                            Industrial
                        </span>
                    </div>
                    <p className="max-w-xs text-sm leading-relaxed text-muted-foreground">
                        A unit of Velox Chemicals Pvt. Ltd.
                        <br />
                        Thoothukudi, Tamil Nadu, India.
                    </p>
                </div>
                <div>
                    <h5 className="mb-4 font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
                        Compliance
                    </h5>
                    <ul className="space-y-2 text-sm">
                        {compliance.map((item) => (
                            <li key={item}>{item}</li>
                        ))}
                    </ul>
                </div>
                <div>
                    <h5 className="mb-4 font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
                        Inquiries
                    </h5>
                    <p className="mb-4 text-sm">md@veloxrareearths.com</p>
                    <div className="h-px w-full bg-border" />
                    <p className="mt-4 font-mono text-[11px] text-muted-foreground">
                        © 2026 VELOX INDUSTRIAL
                    </p>
                </div>
            </div>
        </footer>
    );
}
